import React, { ReactNode, useState } from 'react'
import { Box, BoxProps, Flex } from 'theme-ui'
/**@todo change import path, dont use relative path */
import { keyframes } from '@emotion/react'
import useCurrentUserStore from '../../stores/currentUser'

interface SidebarProps {
  menus?: MenuProps[]
  sx?: BoxProps['sx']
}

export default function Sidebar(props: SidebarProps) {
  const { currentUser } = useCurrentUserStore()

  const isAdmReviewer = currentUser?.data?.roles === 'admin_reviewer'
  const isAdmInvestigate = currentUser?.data?.roles === 'admin_investigator'

  return (
    <Box
      bg="black"
      sx={{
        height: '100%',
        width: '60px',
        zIndex: 1,
        position: 'fixed',
        mt: '70px',
        ...props.sx,
      }}
      role="navigation"
    >
      <Box as="ul" sx={{ listStyleType: 'none', pl: 0 }}>
        {isAdmReviewer || isAdmInvestigate
          ? props.menus
              ?.filter((menu) => menu.label !== 'Create Report')
              .map((menu, i) => {
                return <Menu key={i} {...menu} />
              })
          : props.menus?.map((menu, i) => {
              return <Menu key={i} {...menu} />
            })}
      </Box>
    </Box>
  )
}

// =============================================================================
// Menu
// =============================================================================

interface MenuProps {
  icon: ReactNode
  label: ReactNode
  onClick?(): void
}

function Menu({ icon: Icon, label, onClick }: MenuProps) {
  const [hovered, setHovered] = useState(false)

  function handleEvent(type: string, event: any) {
    switch (type) {
      case 'mouseEnter':
        return setHovered(true)
      case 'mouseLeave':
        return setHovered(false)
      default:
        return
    }
  }

  return (
    <Flex
      as="li"
      color="white"
      sx={{
        height: '60px',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        cursor: 'pointer',
        zIndex: 5,
        ':hover': {
          bg: 'primary',
        },
      }}
      onMouseEnter={(e) => handleEvent('mouseEnter', e)}
      onMouseLeave={(e) => handleEvent('mouseLeave', e)}
      onClick={onClick}
    >
      <Flex
        sx={{
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          width: '60px',
          maxWidth: '60px',
          zIndex: 5,
        }}
      >
        {Icon}
      </Flex>
      {hovered && (
        <Flex
          pr="3"
          sx={{
            alignItems: 'center',
            height: '100%',
            position: 'absolute',
            left: '100%',
            whiteSpace: 'nowrap',
            bg: 'primary',
            zIndex: 4,
            color: 'transparent',
            transformOrigin: 'left',
            animation: `${translateX} 0.1s ease-in 0s 1, ${textFadeIn} 0.3s linear 0.1s 1 normal forwards`,
          }}
        >
          {label}
        </Flex>
      )}
    </Flex>
  )
}

const translateX = keyframes`
  from { transform: scaleX(0) }
  to { transform: scaleX(1) }
`

const textFadeIn = keyframes`
  from { color: transparent }
  to { color: white }
`
